import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    createApprovals: {
        method: 'POST',
        url: `${BASE_PATH_API}/approvals`
    },
    getPotentialApprovers: {
        method: 'GET',
        url: `${BASE_PATH_API}/v2/approvals/potentialApprovers`,
        isArray: true
    },
    updateApprovals: {
        method: 'POST',
        url: `${BASE_PATH_API}/v2/approvals`
    },
    updateBulkApprovals: {
        method: 'PUT',
        url: `${BASE_PATH_API}/v1/approvals/bulk`
    },
    recordBulkApprovals: {
        method: 'POST',
        url: `${BASE_PATH_API}/v1/approvals/bulk`
    },
    sendReminder: {
        method: 'POST',
        url: `${BASE_PATH_API}/v2/approvals/reminder`
    },
    getStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/approvals/bills/:billId/status`,
        isArray: true
    },
    approveBill: {
        method: 'POST',
        url: `${BASE_PATH_API}/journals/:billId/approvals`
    },
    deleteBillApproval: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/approvals/:approvalId`
    },
    getApprovals: {
        method: 'GET',
        url: `${BASE_PATH_API}/v2/approvals/bills/:billId`,
        isArray: true
    },
    getBillApprovalAggregateStatuses: {
        method: 'POST',
        url: `${BASE_PATH_API}/v1/approvals/aggregateStatuses/get`,
        isArray: true,
        transformRequestData: function transformRequestData(data) {
            return data.filter(x => !!x);
        }
    },
    getPendingResidentApprovals: {
        method: 'GET',
        url: `${BASE_PATH_API}/v1/boardMembers/approvals/counts`,
        isArray: true
    },
    getRejectionReasons: {
        method: 'GET',
        url: `${BASE_PATH_API}/v1/approvals/rejectionReasons`,
        isArray: true
    }
};

export function ApprovalsApi() {
    return createActions(actions);
}
